import { render, staticRenderFns } from "./avatarItem.vue?vue&type=template&id=42460824&scoped=true&"
import script from "./avatarItem.vue?vue&type=script&lang=js&"
export * from "./avatarItem.vue?vue&type=script&lang=js&"
import style0 from "./avatarItem.vue?vue&type=style&index=0&id=42460824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42460824",
  null
  
)

export default component.exports